import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";

export const useMerciInArrivoStore = defineStore("merciInArrivoStore", {
  state: () => ({
    merciInArrivo: [],
    caricandoMerci: false,
    errorMessage: ""
  }),
  actions: {
    async getMerciInArrivoOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoMerci = true;
      await getData("/api/merci/arrivo");
      if (!messageError.value) {
        this.merciInArrivo = data.value;
        this.caricandoMerci = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    }
  }
});
